"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const feature_styles_1 = require("@/components/common/feature/feature.styles");
require("@/components/common/text/semantics/text-block");
require("@/components/common/avatar");
require("@/components/common/icon");
let Feature = class Feature extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.emoji = '';
        this.heading = '';
        this.description = '';
        this.centered = false;
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderVisual()}

      <mm-text-block
        level="3"
        ?centered=${this.centered}
        .heading=${this.heading}
        .description=${this.description}
      ></mm-text-block>

      <slot></slot>
    `;
    }
    renderVisual() {
        if (!this.emoji && !this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-avatar variant="secondary" size="48">${this.renderGlyph()}</mm-avatar>
    `;
    }
    // 제품 의미를 갖는 기호는 icon, 콘텐츠로 고른 글자는 emoji로 받고, 둘이 함께 오면 emoji를 우선한다.
    renderGlyph() {
        if (this.emoji) {
            return (0, lit_1.html) `
        <span class="feature-emoji" aria-hidden="true">${this.emoji}</span>
      `;
        }
        return (0, lit_1.html) `
      <mm-icon size="large" name=${this.icon}></mm-icon>
    `;
    }
};
Feature.styles = [feature_styles_1.featureStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Feature.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Feature.prototype, "emoji", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Feature.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Feature.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], Feature.prototype, "centered", void 0);
Feature = __decorate([
    (0, decorators_js_1.customElement)('mm-feature')
], Feature);
exports.Feature = Feature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZlYXR1cmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQStDO0FBQy9DLHFEQUEyRDtBQUUzRCwrRUFBMEU7QUFFMUUseURBQXNEO0FBQ3RELHNDQUFtQztBQUNuQyxvQ0FBaUM7QUFHMUIsSUFBTSxPQUFPLEdBQWIsTUFBTSxPQUFRLFNBQVEsZ0JBQVU7SUFBaEM7O1FBR3VCLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ1osZ0JBQVcsR0FBRyxFQUFFLENBQUE7UUFDQSxhQUFRLEdBQUcsS0FBSyxDQUFBO0lBcUM5RCxDQUFDO0lBbkNDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO1FBQ1AsSUFBSSxDQUFDLFlBQVksRUFBRTs7OztvQkFJUCxJQUFJLENBQUMsUUFBUTttQkFDZCxJQUFJLENBQUMsT0FBTzt1QkFDUixJQUFJLENBQUMsV0FBVzs7OztLQUlsQyxDQUFBO0lBQ0gsQ0FBQztJQUVPLFlBQVk7UUFDbEIsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRTdDLE9BQU8sSUFBQSxVQUFJLEVBQUE7aURBQ2tDLElBQUksQ0FBQyxXQUFXLEVBQUU7S0FDOUQsQ0FBQTtJQUNILENBQUM7SUFFRCxtRUFBbUU7SUFDM0QsV0FBVztRQUNqQixJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDZCxPQUFPLElBQUEsVUFBSSxFQUFBO3lEQUN3QyxJQUFJLENBQUMsS0FBSztPQUM1RCxDQUFBO1NBQ0Y7UUFFRCxPQUFPLElBQUEsVUFBSSxFQUFBO21DQUNvQixJQUFJLENBQUMsSUFBSTtLQUN2QyxDQUFBO0lBQ0gsQ0FBQzs7QUF6Q00sY0FBTSxHQUFHLENBQUMsOEJBQWEsQ0FBQyxDQUFBO0FBQ0g7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3FDQUFnQjtBQUNmO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztzQ0FBVztBQUNWO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt3Q0FBYTtBQUNaO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs0Q0FBaUI7QUFDQTtJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzt5Q0FBaUI7QUFOakQsT0FBTztJQURuQixJQUFBLDZCQUFhLEVBQUMsWUFBWSxDQUFDO0dBQ2YsT0FBTyxDQTJDbkI7QUEzQ1ksMEJBQU8ifQ==